module.exports = __webpack_public_path__ + "img/anip.ee192547.png";